module.exports = __webpack_public_path__ + "media/images/pc/staffs/mv_planner-b049598e9fc81539b1f9cf81ca71a4ed.webp";